<app-layout-container>
  <section class="legal-hero">
    <app-section-heading [animateTitle]="true"
                         animateTitleTrigger="in-view"
                         eyebrow="Legal"
                         title="Legal and policy information"
                         text="Select a document below to view its details.">
    </app-section-heading>
  </section>
</app-layout-container>

<app-layout-container>
  <section class="legal-sections">
    <div class="legal-sections__grid">
      @for (card of legalCards; track card.key) {
      <article class="legal-card"
               role="button"
               tabindex="0"
               [class.legal-card--active]="selectedDocumentKey === card.key"
               [attr.aria-pressed]="selectedDocumentKey === card.key"
               [attr.aria-current]="selectedDocumentKey === card.key ? 'true' : null"
               (click)="onSelectDocument(card.key)"
               (keydown.enter)="onSelectDocument(card.key)"
               (keydown.space)="onSelectDocument(card.key); $event.preventDefault()">
        <h2>{{ card.title }}</h2>
        <p>{{ card.summary }}</p>
      </article>
      }
    </div>
  </section>
</app-layout-container>

<app-layout-container>
  <section class="legal-detail">
    <div class="legal-detail__panel">
      <app-section-heading [animateTitle]="true"
                           animateTitleTrigger="in-view"
                           eyebrow="Document sections"
                           [title]="selectedDocumentTitle"
                           text="Select any legal section above to view the full document content.">
      </app-section-heading>

      @if (selectedDocument; as document) {
      <article class="legal-document">
        <header class="legal-document__meta">
          @if (document.companyName) {
          <p class="legal-document__company">{{ document.companyName }}</p>
          }
          <div class="legal-document__meta-items">
            @if (document.lastUpdated) {
            <span>Last updated: {{ document.lastUpdated }}</span>
            }
            @if (document.version) {
            <span>Version: {{ document.version }}</span>
            }
          </div>
        </header>

        @for (section of document.sections; track $index) {
        <section class="legal-document__section">
          <h3>{{ section.heading }}</h3>

          @if (section.content?.length) {
          @for (paragraph of section.content; track $index) {
          <p>{{ paragraph }}</p>
          }
          }

          @if (section.listItems?.length) {
          @if (section.listType === 'number') {
          <ol>
            @for (item of section.listItems; track $index) {
            <li>{{ item }}</li>
            }
          </ol>
          } @else {
          <ul>
            @for (item of section.listItems; track $index) {
            <li>{{ item }}</li>
            }
          </ul>
          }
          }

          @if (section.subSections?.length) {
          <div class="legal-document__subsections">
            @for (subSection of section.subSections; track $index) {
            <div class="legal-document__subsection">
              <h4>{{ subSection.subHeading }}</h4>

              @if (subSection.content?.length) {
              @for (paragraph of subSection.content; track $index) {
              <p>{{ paragraph }}</p>
              }
              }

              @if (subSection.listItems?.length) {
              @if (subSection.listType === 'number') {
              <ol>
                @for (item of subSection.listItems; track $index) {
                <li>{{ item }}</li>
                }
              </ol>
              } @else {
              <ul>
                @for (item of subSection.listItems; track $index) {
                <li>{{ item }}</li>
                }
              </ul>
              }
              }

              @if (subSection.footerText) {
              <p class="legal-document__footer">{{ subSection.footerText }}</p>
              }
            </div>
            }
          </div>
          }

          @if (section.footerText) {
          <p class="legal-document__footer">{{ section.footerText }}</p>
          }

          @if (section.contactEmail) {
          <p>
            Contact: <a [href]="'mailto:' + section.contactEmail">{{ section.contactEmail }}</a>
          </p>
          }
        </section>
        }
      </article>
      } @else {
      <div class="legal-document legal-document--empty">
        <p>Legal document content is not available right now.</p>
      </div>
      }
    </div>
  </section>
</app-layout-container>

<app-layout-container>
  <section class="legal-bottom-cta">
    <app-cta-banner [animateTitle]="false"
                    animateTitleTrigger="in-view"
                    eyebrow="Questions?"
                    title="Need help understanding something?"
                    text="If you have questions about policies, terms, or communications, reach out and we’ll help point you in the right direction."
                    primaryLabel="Contact Us"
                    primaryLink="/contact-us"
                    secondaryLabel="About Us"
                    secondaryLink="/about-us">
    </app-cta-banner>
  </section>
</app-layout-container>
